var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./cardWorkforce.ts"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3b8ff25c\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./cardWorkforce.vue.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/home/cards/cardWorkforce/cardWorkforce.vue.html
// module id = zCat
// module chunks = 2